/**
 * StatePill — maps domain state strings to semantic colour tokens.
 * Covers batch states, match account/entry states, and generic states.
 */

type StateName =
  | 'draft' | 'verified' | 'archived' | 'posted'  // batch
  | 'open'  | 'settled'  | 'void'                  // generic
  | 'active' | 'inactive' | 'closed'               // account
  | 'computed' | 'locked' | 'pending_confirmation' // settlement
  | string;                                         // fallback

const STATE_CLASSES: Record<string, string> = {
  // Batch
  draft:    'bg-amber-50 text-amber-700 border border-amber-200',
  verified: 'bg-emerald-50 text-emerald-700 border border-emerald-200',
  archived: 'bg-blue-50 text-blue-700 border border-blue-200',
  posted:   'bg-blue-50 text-blue-700 border border-blue-200',
  // Generic
  open:     'bg-brand-light text-brand border border-brand/20',
  settled:  'bg-surface-raised text-ink-muted border border-border',
  void:     'bg-red-50 text-neg border border-red-200',
  // Account
  active:   'bg-emerald-50 text-emerald-700 border border-emerald-200',
  inactive: 'bg-amber-50 text-amber-700 border border-amber-200',
  closed:   'bg-surface-raised text-ink-muted border border-border',
  // Settlement
  computed:             'bg-amber-50 text-amber-700 border border-amber-200',
  locked:               'bg-emerald-50 text-emerald-700 border border-emerald-200',
  pending_confirmation: 'bg-surface-raised text-ink-muted border border-border',
};

export function StatePill({ state }: { state: StateName }) {
  const cls =
    STATE_CLASSES[state] ?? 'bg-surface-raised text-ink-muted border border-border';
  const label = state.replace(/_/g, ' ');
  return (
    <span
      className={[
        'inline-flex items-center rounded-full px-2.5 py-0.5 text-caption font-medium capitalize',
        cls,
      ].join(' ')}
    >
      {label}
    </span>
  );
}
